import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

export const createCustomPageExperienceId = 'company-hub.custom-page.create';
export const updateCustomPageExperienceId = 'company-hub.custom-page.update';

export const createCustomPageExperience = new UFOExperience(createCustomPageExperienceId, {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const updateCustomPageExperience = new UFOExperience(updateCustomPageExperienceId, {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});

